import React from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';
import { withHandlers, withState, compose, withPropsOnChange } from 'recompose';
import { t } from '../../../../../modules/infra/i18n';

import SimpleCheckbox from '../../../../common/simpleCheckbox';

const ShopField = (field) => (
  <div className="c-checkbox">
    <SimpleCheckbox
      name={field.assignedName}
      id={`shop-${field.index}`}
      label={field.input.value}
    />
  </div>
);

const ShopInputs = ({ fields }) => (
  <div className="c-checkbox-list">
    {
      fields.map((shop, index) => (
        <div className="c-checkbox-list__item" key={index}>
          <Field
            name={`${shop}.name`}
            index={index}
            assignedName={`${shop}.assigned`}
            component={ShopField}
          />
        </div>
      ))
    }
  </div>
);

const AssignedShops = ({ selectAll, allSelected }) => (
  <div>
    <button type="button" className="c-btn c-btn--small u-mv--" onClick={selectAll}>
      <span className="c-btn__text">{allSelected ? t('settings:promo_codes.assigned_shops.unselect_all') : t('settings:promo_codes.assigned_shops.select_all')}</span>
    </button>
    <FieldArray name="shops" component={ShopInputs} />
  </div>
);

AssignedShops.propTypes = {
  selectAll: PropTypes.func.isRequired,
  allSelected: PropTypes.bool.isRequired,
};

const isAllSelected = (shops = []) => shops.length && shops.every((s) => s.assigned);

export default compose(
  withState('allSelected', 'setAllSelected', (props) => isAllSelected(props.shops)),
  withHandlers({
    selectAll: (props) => () => {
      const allSelected = isAllSelected(props.shops);
      props.shops.forEach((barber, index) => {
        props.change(`shops[${index}].assigned`, !allSelected);
      });
    },
  }),
  withPropsOnChange(
    ['shops'],
    (props) => {
      props.setAllSelected(isAllSelected(props.shops));
    },
  )
)(AssignedShops);
